import React, { Component } from 'react'
import Text3D from './../text3D/Text3D.jsx'

// Wrapper component that defines callbacks to manipulate attributes on callbacks to drive animations
// on wrapped 3d mesh component

class TriggerText3D extends Component {
    constructor(props) {
        super(props)
        this.actions = {}
        this.mixer
        this.clock = new THREE.Clock()

        // Defines where text is in relation to root object
        this.offsetPosition =
            props.triggerType === 'circle'
                ? {
                      x: 0.1,
                      y: -0.1,
                      z: 0.2,
                  }
                : {
                      x: 0.3,
                      y: -0.1,
                      z: -0.15,
                  }

        this.createAnimations = this.createAnimations.bind(this)
    }

    // Figure this out later for touch tilt
    // Not really an animation, more of an augmentation of spatial displacement
    // Need to do it in a way that doesn't throttle update cycle
    // handleParallaxDisplacement

    // Sets this up as a placeholder
    // Separated initial reveal from other controlled reveal in case we wanted separate animation for it
    // Invoked in different place in mesh creation process
    // handleInitialReveal = (obj)=>{
    //     // obj.material.opacity = 1
    // }

    // handleInitialHide = (obj)=>{
    //     // obj.material.opacity = 1
    // }

    // Invokes animations associated with revealing the text
    handleReveal = () => {
        // plays reveals animation
        this.actions.revealOpacityClip && this.actions.revealOpacityClip.play()
        this.actions.translateUpClip && this.actions.translateUpClip.play()
        this.actions.scaleUpClip && this.actions.scaleUpClip.play()

        // Stops hide animations b/c they are clamped
        this.actions.hideOpacityClip && this.actions.hideOpacityClip.stop()
        this.actions.scaleOutClip && this.actions.scaleOutClip.stop()
    }

    // Invokes animations associated with hiding the text
    handleHide = () => {
        // plays hide animation
        this.actions.hideOpacityClip && this.actions.hideOpacityClip.play()
        this.actions.scaleOutClip && this.actions.scaleOutClip.play()

        // Stops reveal animations b/c they are clamped
        this.actions.revealOpacityClip && this.actions.revealOpacityClip.stop()
        this.actions.translateUpClip && this.actions.translateUpClip.stop()
        this.actions.scaleUpClip && this.actions.scaleUpClip.stop()
    }

    // Invoked in set up of child component to associate animation with provided object
    createAnimations = obj => {
        this.mixer = new THREE.AnimationMixer(obj)

        var revealOpacityKF = new THREE.VectorKeyframeTrack('.material.opacity', [0, 0.75], [0, 1])
        var revealOpacityClip = new THREE.AnimationClip('visited', 0.75, [revealOpacityKF])
        this.actions.revealOpacityClip = this.mixer.clipAction(revealOpacityClip)
        this.actions.revealOpacityClip.loop = THREE.LoopOnce
        this.actions.revealOpacityClip.clampWhenFinished = true

        var scaleUpKF = new THREE.VectorKeyframeTrack('.scale', [0, 0.75], [0.00001, 0.00001, 0.00001, 1, 1, 1])
        var scaleUpClip = new THREE.AnimationClip('visited', 0.75, [scaleUpKF])
        this.actions.scaleUpClip = this.mixer.clipAction(scaleUpClip)
        this.actions.scaleUpClip.loop = THREE.LoopOnce
        this.actions.scaleUpClip.clampWhenFinished = true

        var hideOpacityKF = new THREE.VectorKeyframeTrack('.material.opacity', [0, 0.75], [1, 0])
        var hideOpacityClip = new THREE.AnimationClip('visited', 0.75, [hideOpacityKF])
        this.actions.hideOpacityClip = this.mixer.clipAction(hideOpacityClip)
        this.actions.hideOpacityClip.loop = THREE.LoopOnce
        this.actions.hideOpacityClip.clampWhenFinished = true

        var translateUpKF = new THREE.VectorKeyframeTrack(
            '.position',
            [0, 0.75],
            [
                this.offsetPosition.x,
                this.offsetPosition.y - 0.2,
                this.offsetPosition.z,
                this.offsetPosition.x,
                this.offsetPosition.y,
                this.offsetPosition.z,
            ]
        )
        var translateUpClip = new THREE.AnimationClip('visited', 0.75, [translateUpKF])
        this.actions.translateUpClip = this.mixer.clipAction(translateUpClip)
        this.actions.translateUpClip.loop = THREE.LoopOnce
        this.actions.translateUpClip.clampWhenFinished = true

        var scaleOutKF = new THREE.VectorKeyframeTrack('.scale', [0, 0.75], [1, 1, 1, 0.00001, 0.00001, 0.00001])
        var scaleOutClip = new THREE.AnimationClip('visited', 0.75, [scaleOutKF])
        this.actions.scaleOutClip = this.mixer.clipAction(scaleOutClip)
        this.actions.scaleOutClip.loop = THREE.LoopOnce
        this.actions.scaleOutClip.clampWhenFinished = true

        this.animateMixer()
    }

    animateMixer = () => {
        var delta = this.clock.getDelta()
        this.mixer && this.mixer.update(delta)
        this.raf = requestAnimationFrame(this.animateMixer)
    }

    componentWillUnmount() {
        this.raf && cancelAnimationFrame(this.raf)
    }

    render() {
        const { position, rootObj, camera, currentState, isVisible, ...props } = this.props
        return (
            <Text3D
                rootObj={rootObj}
                handleHide={this.handleHide}
                handleReveal={this.handleReveal}
                handleInitialReveal={this.handleInitialReveal}
                relativePosition={this.offsetPosition}
                createAnimations={this.createAnimations}
                camera={camera}
                faceCamera={true}
                height={0.001}
                size={0.05}
                isVisible={isVisible}
                {...props}
            />
        )
    }
}

export default TriggerText3D
